import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import {
    DialogActions,
    DialogContent,
    Paper
} from 'material-ui';
import Button from 'material-ui/Button';
import Input, { InputAdornment, InputLabel } from 'material-ui/Input';
import IconButton from 'material-ui/IconButton';
import { FormControl, FormHelperText } from 'material-ui/Form';
import { Lock, Visibility, VisibilityOff } from 'material-ui-icons';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import { getUserInformation } from '../Login/loginService';
import { translate } from 'react-i18next';
import { validatePassword, changePassword } from './ChangePasswordService';
import i18n from '../../services/i18n.js';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    dialogTitle: {
        fontWeight: '300',
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main
    }
});

/**
 * Componente modal que permite la carga de datos utilizados en el envío de mail.
 * Si recibe la propiedad "title" la utiliza como título del diálogo. En caso
 * de que no la reciba, muestra el título "Enviar correo".
 * Debe recibir 2 funciones:
 *      onClose: llamada al cerrar el diálogo.
 *      getEmailFrom: función que debe devolver la dirección de correo desde la
 *                  cual enviar el correo.
 */
class ChangePasswordDialog extends React.Component {
    constructor(props) {
        super(props);

        this.currentUser = getUserInformation();

        this.state = {
            user: {
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
            success: false,
            loading: false,
            currentPasswordFailed: true,
            failed: true,
            disableChangeButton: true,
            showConfirmPassword: false,
            showCurrentPassword: false,
            showNewPassword: false
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            success: false,
            loading: false,
            currentPasswordFailed: true,
            failed: true,
            disableChangeButton: true,
            showConfirmPassword: false,
            showCurrentPassword: false,
            showNewPassword: false
        });
    }

    handleClose = () => {
        if (!this.state.loading) {
            this.setState({ success: false, loading: true });
        }

        this.changePassword().then(result => {
            if (result.errorCode && result.errorCode !== 200) {
                this.setState({
                    success: false,
                    loading: false
                });
                const message = result.message.substring(result.message.indexOf(':') + 1).trim();
                alert(i18n.t('CHANGE_PASSWORD.CHANGE_PASSWORD_ERROR') + '\n' + message);
            }
            else {
                alert(i18n.t('RECOVER_PASSWORD.RECOVER_SUCCESS'));
                this.setState({ success: true, loading: false });
                this.props.onClose();
            }
        });
    };

    changePassword = async () => {
        try {
            return await changePassword(this.state.user.currentPassword,
                this.state.user.newPassword);
        } catch (error) {
            return error;
        }
    };

    handleCancel = () => {
        this.props.onClose(null);
    };

    handleCurrentPasswordChange(data) {
        let useraux = this.state.user;
        useraux['currentPassword'] = data;

        this.setState({
            user: useraux,
            currentPasswordFailed: (data.length === 0),
            disableChangeButton: (data.length === 0) || this.state.failed,
            message: data.length === 0 ? 'CHANGE_PASSWORD.ENTER_USER_PASSWORD' : ''
        });
    }

    handleNewPasswordChange(data) {
        let user = this.state.user;
        user['newPassword'] = data;
        this.setState({ user });
        this.validatePassword();

    }

    handleConfirmPasswordChange(data) {
        let user = this.state.user;
        user['confirmPassword'] = data;
        this.setState({ user });
        this.validatePassword();
    }

    validatePassword() {
        const validationResult = validatePassword(this.state.user.newPassword,
            this.state.user.confirmPassword);

        this.setState({
            failed: validationResult.failed,
            disableChangeButton: validationResult.failed,
            message: validationResult.message
        });

    }

    render() {

        const { classes, title, t, ...other } = this.props;

        if (!this.state)
            return '';

        const { loading, disableChangeButton, currentPasswordFailed, failed, message } = this.state;

        return (
            <Dialog
                onClose={this.handleClose}
                onEnter={this.handleEnter}
                aria-labelledby="change-password-dialog"
                fullWidth={true}
                maxWidth='sm'
                {...other}
            >
                <DialogTitle
                    id="change-password-dialog"
                    disableTypography={true}
                    className={classes.dialogTitle}>
                    {t('CHANGE_PASSWORD.CHANGE_PASSWORD')}
                </DialogTitle>
                <DialogContent>
                    <Paper style={{ padding: '12px' }} elevation={0}>
                        <FormControl fullWidth error={currentPasswordFailed}>
                            <InputLabel htmlFor="currentPassword">
                                {t('CHANGE_PASSWORD.CURRENT_PASSWORD')}
                            </InputLabel>
                            <Input
                                id="currentPassword"
                                type={this.state.showCurrentPassword ? 'text' : 'password'}
                                startAdornment={<Lock />}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => this.setState({ showCurrentPassword: !this.state.showCurrentPassword })}
                                        >
                                            {this.state.showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                onChange={event => {
                                    this.handleCurrentPasswordChange(String(event.target.value));
                                }}
                            />
                        </FormControl>
                        <span> </span>
                        <FormControl fullWidth error={failed}>
                            <InputLabel htmlFor="newPassword">{t('CHANGE_PASSWORD.NEW_PASSWORD')}</InputLabel>
                            <Input
                                id="newPassword"
                                type={this.state.showNewPassword ? 'text' : 'password'}
                                startAdornment={<Lock />}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => this.setState({ showNewPassword: !this.state.showNewPassword })}
                                        >
                                            {this.state.showNewPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                onChange={event => {
                                    this.handleNewPasswordChange(String(event.target.value));
                                }}
                            />
                        </FormControl>
                        <span> </span>
                        <FormControl fullWidth error={failed}>
                            <InputLabel htmlFor="confirmPassword">{t('CHANGE_PASSWORD.CONFIRM_PASSWORD')}</InputLabel>
                            <Input
                                id="confirmPassword"
                                type={this.state.showConfirmPassword ? 'text' : 'password'}
                                startAdornment={<Lock />}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => this.setState({ showConfirmPassword: !this.state.showConfirmPassword })}
                                        >
                                            {this.state.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                onChange={event => {
                                    this.handleConfirmPasswordChange(String(event.target.value));
                                }}
                            />
                        </FormControl>
                        {failed ? (
                            <FormHelperText
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}
                            >
                                {t(message)}
                            </FormHelperText>
                        ) : (
                            ''
                        )}
                    </Paper>
                </DialogContent>
                <DialogActions className={classes.root} style={{ padding: '12px' }}>
                    <div className={classes.wrapper}>
                        <Button disabled={loading}
                            onClick={this.handleCancel} >
                            {t('CHANGE_PASSWORD.CANCEL_BUTTON')}
                        </Button>
                    </div>
                    <div className={classes.wrapper}>
                        <Button variant="raised"
                            color="primary"
                            disabled={loading || disableChangeButton}
                            onClick={this.handleClose}>
                            {t('CHANGE_PASSWORD.ACCEPT_BUTTON')}
                            {loading && <CircularProgress size={22} className={classes.buttonProgress} />}
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
        );
    }
}

ChangePasswordDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
};

export default translate('translations')(withStyles(styles)(ChangePasswordDialog));


// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePasswordDialog.js